import React, { useEffect } from 'react';

const StarBackground = () => {
  useEffect(() => {
    createStars();
    createShootingStars();
  }, []);

  function createStars() {
    const starsContainer = document.getElementById('stars');
    const numberOfStars = 300;

    for (let i = 0; i < numberOfStars; i++) {
      const star = document.createElement('div');
      star.className = 'star';
      star.style.width = `${Math.random() * 3}px`;
      star.style.height = star.style.width;
      star.style.top = `${Math.random() * 100}%`;
      star.style.left = `${Math.random() * 100}%`;
      star.style.animationDuration = `${Math.random() * 3 + 1}s`;
      starsContainer.appendChild(star);
    }
  }

  function createShootingStars() {
    const shootingStarsContainer = document.getElementById('shooting-stars');
    const numberOfShootingStars = 10;

    for (let i = 0; i < numberOfShootingStars; i++) {
      const shootingStar = document.createElement('div');
      shootingStar.className = 'shooting-star';
      shootingStar.style.top = `${Math.random() * 100}%`;
      shootingStar.style.left = `${Math.random() * 100}%`;
      shootingStar.style.animationDelay = `${Math.random() * 5}s`;
      shootingStarsContainer.appendChild(shootingStar);
    }
  }

  return (
    <>
      <div id="stars"></div>
      <div id="shooting-stars"></div>
    </>
  );
};

export default StarBackground;